import {
  html,
  //svg,
  // SVGTemplateResult,
  TemplateResult,
  //CSSResultGroup,
} from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import componentStyles from './ghs-logo.css.lit';
import {
  ghsLogoMain,
  ghsLogoWhite,
  ghsLogoCMH,
  ghsLogoBAH,
  ghsLogoPLH,
  ghsLogoSJH,
  ghsLogoTCH,
  ghsLogoMVH,
  ghsLogoSEH,
  ghsLogoIcon,
  ghsLogoMedFound,
  ghsLogoGRHelpLine,
  ghsLogoCompGoodbye,
  ghsLogoEnvision,
  ghsLogoRTS,
  ghsLogoTAB,
  ghsLogoAWC,
  ghsLogoTWC,
  ghsLogoHRC,
  bhLogoMain,
  bhLogoMainWhite,
  bhLogoBenefits,
  bhLogoFitness,
  bhLogoPharmacy,
  bhLogoMyBellin,
  bhLogoBellinRun,
  bhLogoBellinRunWhite,
} from './ghs-logo-logos';

export type LogoVariantType =
  | 'ghsLogoMain'
  | 'ghsLogoWhite'
  | 'ghsLogoCMH'
  | 'ghsLogoBAH'
  | 'ghsLogoPLH'
  | 'ghsLogoSJH'
  | 'ghsLogoTCH'
  | 'ghsLogoMVH'
  | 'ghsLogoSEH'
  | 'ghsLogoIcon'
  | 'ghsLogoMedFound'
  | 'ghsLogoGRHelpLine'
  | 'ghsLogoCompGoodbye'
  | 'ghsLogoEnvision'
  | 'ghsLogoRTS'
  | 'ghsLogoTAB'
  | 'ghsLogoAWC'
  | 'ghsLogoTWC'
  | 'ghsLogoHRC'
  | 'bhLogoMain'
  | 'bhLogoMainWhite'
  | 'bhLogoBenefits'
  | 'bhLogoFitness'
  | 'bhLogoPharmacy'
  | 'bhLogoMyBellin'
  | 'bhLogoBellinRun'
  | 'bhLogoBellinRunWhite';

export const logos = {
  ghsLogoMain,
  ghsLogoWhite,
  ghsLogoCMH,
  ghsLogoBAH,
  ghsLogoPLH,
  ghsLogoSJH,
  ghsLogoTCH,
  ghsLogoMVH,
  ghsLogoSEH,
  ghsLogoIcon,
  ghsLogoMedFound,
  ghsLogoGRHelpLine,
  ghsLogoCompGoodbye,
  ghsLogoEnvision,
  ghsLogoRTS,
  ghsLogoTAB,
  ghsLogoAWC,
  ghsLogoTWC,
  ghsLogoHRC,
  bhLogoMain,
  bhLogoMainWhite,
  bhLogoBenefits,
  bhLogoFitness,
  bhLogoPharmacy,
  bhLogoMyBellin,
  bhLogoBellinRun,
  bhLogoBellinRunWhite,
};

export const logoVariantOptions: LogoVariantType[] = [
  'ghsLogoMain',
  'ghsLogoWhite',
  'ghsLogoCMH',
  'ghsLogoBAH',
  'ghsLogoPLH',
  'ghsLogoSJH',
  'ghsLogoTCH',
  'ghsLogoMVH',
  'ghsLogoSEH',
  'ghsLogoIcon',
  'ghsLogoMedFound',
  'ghsLogoGRHelpLine',
  'ghsLogoCompGoodbye',
  'ghsLogoEnvision',
  'ghsLogoRTS',
  'ghsLogoTAB',
  'ghsLogoAWC',
  'ghsLogoTWC',
  'ghsLogoHRC',
  'bhLogoMain',
  'bhLogoMainWhite',
  'bhLogoBenefits',
  'bhLogoFitness',
  'bhLogoPharmacy',
  'bhLogoMyBellin',
  'bhLogoBellinRun',
  'bhLogoBellinRunWhite',
];

/**
 * The GHS logo component.
 * @element ghs-logo
 * @todo update component to behave like the icon component, or extend an outline-svg component
 */
@customElement('ghs-logo')
export class GhsLogo extends OutlineElement {
  static styles = [componentStyles];

  /**
   * The logo variant
   * @param logoVariant
   * @default ghsLogoMain
   *
   * The exported type that drives this is used in other places for domain work.
   */

  @property({ type: String, reflect: true, attribute: 'logo-variant' })
  logoVariant: LogoVariantType = 'ghsLogoMain';

  render(): TemplateResult {
    return html`<div class="ghs-logo">${logos[this.logoVariant]}</div> `;
  }
}
